export default __webpack_public_path__ + "343ef1db20d93548763e5579fb62642c.svg";